import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/config";

export const useClientRevenueChart = ({ dateRange } = {}) => {
  return useQuery({
    queryKey: ["top-10-clients-chart", dateRange],
    queryFn: async () => {
      const params = { order: "desc" };

      if (dateRange?.from && dateRange?.to) {
        params.start_date = dateRange.from;
        params.end_date = dateRange.to;
      }

      const data = await api.get("top-10-clients-chart", { params });
      return data.data.data;
    },
  });
};
